// import http from '../httpService';
// import axios from 'axios';
// import {BASE_URL, token} from '../../utils/const';
// // import {Toast} from '../../../utils/sweetAlert';
// import {t} from 'react-switch-lang';
// import Swal from 'sweetalert2';

// const main = 'frequency-occurence-risks';

// export function getAllFrequencyOccurenceRisks() {
//   // return http.get(`/frequency-occurence-risks`);
//   return axios({
//     method: 'GET',
//     url: `${BASE_URL}/${main}`,
//     headers: {
//       Authorization: 'Bearer ' + token,
//       Accept: '*/*',
//     },
//   });
// }
// export function addAllFrequencyOccurenceRisks() {
//   return http.post(`/frequency-occurence-risks`);
// }
// export function deleteAllFrequencyOccurenceRisks() {
//   return http.delete(`/frequency-occurence-risks/{id}`);
// }
// export function editAllFrequencyOccurenceRisks() {
//   return http.put(`/frequency-occurence-risks`);
// }

import http from '../httpService';

export function getAllFrequencyOccurenceRisks() {
  return http.get(`/frequency-occurence-risks`);
}

export function updateFrequencyOccurenceRisk(payload) {
  return http.put('/frequency-occurence-risks', payload);
}

export function createFrequencyOccurenceRisk(payload) {
  return http.post('/frequency-occurence-risks', payload);
}

export function deleteFrequencyOccurenceRisk(id) {
  return http.delete(`/frequency-occurence-risks/${id}`);
}
